import { RiEditCircleFill, RiDeleteBin5Fill } from "react-icons/ri";
import { useDispatch } from "react-redux";
import { updatePageLength } from "../features/pagination/paginationSlice";
import {
    editTransaction,
    removeTransaction,
} from "../features/transaction/transactionSlice";
const { FormatMoney } = require("format-money-js");

export const Transaction = ({ transaction }) => {
    const { id, name, type, amount } = transaction;

    const dispacth = useDispatch();

    const fm = new FormatMoney({
        decimals: 0,
    });

    const editHandler = () => {
        dispacth(editTransaction(transaction));
    };

    const deleteHandler = () => {
        dispacth(removeTransaction(id));
        dispacth(updatePageLength(1));
    };

    return (
        <>
            <div
                className={`flex items-center justify-between ${
                    type === "income" ? "bg-blue-400" : "bg-red-400"
                }  p-3 rounded mb-2`}
            >
                <div className="flex items-center">
                    <p className="text-sm text-white">{name}</p>
                    <h4 className="text-sm text-white ml-4">
                        (&#2547;{" "}
                        {type === "income" ? fm.from(amount) : fm.from(-amount)}
                        )
                    </h4>
                </div>
                <div className="flex items-center gap-2">
                    <button
                        onClick={editHandler}
                        className="text-sm text-white"
                    >
                        <RiEditCircleFill />
                    </button>
                    <button
                        onClick={deleteHandler}
                        className="text-sm text-white"
                    >
                        <RiDeleteBin5Fill />
                    </button>
                </div>
            </div>
        </>
    );
};
